export default {
  security_profiles_title: "Security Profile",
  custom_security_profiles_title: "Custom Security",
  searchInSecurityProfiles: "Search in Profiles",
  create_new_security_Profile: "Create New Security",
  create_first_security_Profile: "Create First Profile",
  create_new_security_profile_subtitle:
    "Select & save Security settings for use in devices",
  create_new_security_profile_list_other_security_title: "Categories",
  create_new_security_profile_list_other_security_description:
    "Choose a Security and provide details regarding your company's policies.",
  create_custom_security_profile: "Create custom Security",
  choose_a_name: "Choose a name for this profile",
  choose_a_name_placeholder: "Security name",
  select_os: "Select operating system",
  operating_system: "Operating System Supports",
  custom_title: "Use this section to configure restriction on a device.",
  create_success_descriptio:
    "The custom profile has create, NOW you can Assign Group, User, Device.",
  security_profiles: {
    tabs: {
      all: "All",
      trio_profiles: "Trio Profiles",
      custom: "Custom",
    },
    empty_state_title: "No Custom Profiles",
    empty_state_description:
      "Create Profile to restrict devices in your company",
    create_first_profile: "Create First Profile",
    table: {
      name: "Name",
      category: "Category",
      operation_system: "Operating system",
      device_ownership: "Ownership",
      assigned_to: "Assigned to",
      BYOD: "Available for BYOD",
      CO: "Company-owned",
      COD: "Company-owned",
    },
  },
  security_profile: "Security",
  no_security_profiles: "No Security",
  assign_security_profiles: "Assign Security",
  create_profiles_manage_devices:
    "Create profiles to manage devices within your company.",
  configuration_profile: "Configuration",
  remove_security: "Delete",
  remove_security_profile: "Remove security profile",
  all_security_profiles: "All Security",
  add_security_profile: "Add Security",
  add_exception: "Add exception",
  profile_set: "{{count}} set profiles",
  remove_from_security_profile: "Delete Profile?",
  details: {
    title: "Security details",
    tabs: {
      overview: "Overview",
      check_list: "Check List",
    },
    security_polices_description: "Security Description",
    description: "Description",
    behavior: "Behavior",
    security_behavior: "Security Behavior",
    security_activation: "Security Activation",
    table: {
      os_version: "OS Version",
      value: "Value",
      true: "on",
      false: "off",
      Off: "off",
      On: "on",
    },
  },
  true: "off",
  false: "on",
  assignedToDevicesTip:
    "This profile is activated on \n {{departmentCount}} autopilot, and {{deviceCount}} devices",
  search_empty_state: {
    title: "Couldn’t find your result",
    description: "The profile you searched is not available",
  },
  //new
  category: "Category",
  categorois: "Category",
  suggestions: "Suggestions",
  suggestionInfoDescription:
    "Choose from our comprehensive array of essential security configurations, providing a valuable resource to enhance your organization's security with ease.",
  securityProfilesHeaderDescription:
    "Security Profiles let you configure and enforce key security settings, such as encryption, password policies, screen lock, threat protection, and more, to safeguard devices across your fleet.",
  urlList: "Blocked list",
  noUrlAddedYet: "No URLs yet",
  manually: "Manually",
  manuallUrlSetting: "Manual URL setting",
  blockURL: "Block your URL",
  enterYourUrl: "Enter your URL(s) into the text field",
  setRule: "Set the Rule",
  blocklist: "Block",
  allowList: "Allow",
  enterUrl: "Enter URL",
  tags: "Tags",
  tag: "Tag",
  enterUrlTip: "*Just URLs with https or http are acceptable.",
  item: "Item",
  visitTheLink: "Visit the link",
  editWebContentForm: "Edit URL",
  searchTag: "Search tag",
  emptySearch: "No result found",
  changeProfileNameTitle: "Change profile name?",
  changeProfileNameDescription: "Please type the new profile name in the box.",
};
